module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hide),
      expression: "hide"
    }],
    ref: "menu",
    staticClass: "toggle-menu",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense",
    on: {
      "click": _vm.toggleContent
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.icon))])], 1), (_vm.visible) ? _c('div', {
    ref: "menu_content",
    staticClass: "menu-content md-elevation-1"
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-681d4b15","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleMenu.vue
// module id = 1171
// module chunks = 0